import React, { FC } from 'react';
import { Badge, Box, Flex, Text } from '@mantine/core';
import { useStyles } from './styles';
import { getIndicatorByUserStatus } from '../../../../utils';
import { IUserInfo } from '@/entities/admin-app/user';
import { UserAvatar } from '@/components/user-avatar';
import { useTranslation } from 'react-i18next';
import { EllipsisTooltip } from '@components/EllipsisTooltip';
import { IUsersSortField } from '@components/simple-table/types';

interface IPhotoInfoProps {
  userInfoCommon?: IUserInfo;
}

export const PhotoInfo: FC<IPhotoInfoProps> = ({ userInfoCommon }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { fullLabel, colorBadge } = getIndicatorByUserStatus(userInfoCommon?.Status ?? 0, t);
  const isLdapUser = userInfoCommon?.UserType === IUsersSortField.LDAP;

  const name = `${userInfoCommon?.Common?.SurName || ''} ${
    userInfoCommon?.Common?.FirstName || ''
  } ${userInfoCommon?.Common?.MiddleName || ''}`;

  const email = userInfoCommon?.Credentials?.Email || '';

  return (
    <Box className={classes.photo}>
      <UserAvatar
        user={userInfoCommon?.Common}
        userId={userInfoCommon?.Id}
        size={124}
        src={userInfoCommon?.Avatar}
        notClickable
      />
      <Flex gap={4} align="center" className={classes.badge}>
        <Badge variant="light" color={colorBadge}>
          <Text fw="600" fz="11">
            {fullLabel}
          </Text>
        </Badge>
        {isLdapUser && <Box className={classes.ldapLabel}>LDAP</Box>}
      </Flex>
      <Box className={classes.container} maw="100%">
        <EllipsisTooltip className={classes.name} width={250}>
          {name}
        </EllipsisTooltip>
        <EllipsisTooltip className={classes.email} width={250}>
          {email}
        </EllipsisTooltip>
      </Box>
    </Box>
  );
};
